import {
	GET_SNAPS,
	GET_SNAPS_SUCCESS,
	GET_SNAPS_FAILURE,
	ADD_SNAP_SUCCESS,
	ADD_SNAP_FAILURE,
	EDIT_SNAP_SUCCESS,
	EDIT_SNAP_FAILURE,
	DELETE_SNAP_SUCCESS,
	DELETE_SNAP_FAILURE,
} from './types';

export interface EditSnapPayload {
	id: string;
	chartType: string;
	timeRange?: {
		from: number | null;
		to: number | null;
		unit: string;
		range: string;
		field?: string;
		groupingFields?: string[];
	};
	grouping?: {
		groupingLevel1: string;
		groupingLevel2: string;
	};
	sorting?: {
		field: string;
		order: string;
	};
	fields?: string[];
}

export interface ISnap {
	_id: string;
}

export const defaultState = {
	data: {
		itemsList: [] as ISnap[],
		page: 1,
		totalPages: 1,
	},
	type: '',
	isLoading: true,
	isLoaded: false,
	error: null,
};

export type ISnapsState = typeof defaultState;

export const snaps = (state = defaultState, action: any): ISnapsState => {
	const { type, payload } = action;
	switch (type) {
		case GET_SNAPS:
			return {
				...state,
				type,
				isLoading: true,
				error: null,
			};
		case GET_SNAPS_SUCCESS:
			const fieldedList = [...payload.itemsList].map(item => ({
				...item,
				timeRange: {
					...item?.timeRange, 
					field: item?.timeRange?.field || 'CreatedDate'
				},
			}));
			return {
				...state,
				data: {
					...payload,
					itemsList: [...state.data.itemsList, ...fieldedList],
				},
				type,
				isLoading: false,
				isLoaded: true,
				error: null,
			};
		case GET_SNAPS_FAILURE:
			return {
				...state,
				type,
				isLoading: false,
				isLoaded: true,
				error: payload,
			};
		case ADD_SNAP_SUCCESS:
			return {
				...state,
				data: {
					...state.data,
					itemsList: [payload, ...state.data.itemsList],
				},
				type,
				isLoading: false,
				isLoaded: true,
				error: null,
			};
		case ADD_SNAP_FAILURE:
			return {
				...state,
				type,
				isLoading: false,
				isLoaded: true,
				error: payload,
			};
		case EDIT_SNAP_SUCCESS:
			const updatedItems = state.data.itemsList.map(snap => (snap._id === payload._id) ?  payload : snap);
			return {
				...state,
				data: {
					...state.data,
					itemsList: [...updatedItems],
				},
				type,
				isLoading: false,
				isLoaded: true,
				error: null,
			};
		case EDIT_SNAP_FAILURE:
			return {
				...state,
				type,
				isLoading: false,
				isLoaded: true,
				error: payload,
			};
		case DELETE_SNAP_SUCCESS:
			return {
				...state,
				data: {
					...state.data,
					itemsList: state.data.itemsList.filter(snap => snap._id !== payload),
				},
				type,
				isLoading: false,
				isLoaded: true,
				error: null,
			};
		case DELETE_SNAP_FAILURE:
			return {
				...state,
				type,
				isLoading: false,
				isLoaded: true,
				error: payload,
			};
		default:
			return state;
	}
};
